// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum DistributorRefundCandidateApprovalRejectionReason {
  ExistingCustomerRefundCandidate = "EXISTING_CUSTOMER_REFUND_CANDIDATE",
  ExistingCustomerRefund = "EXISTING_CUSTOMER_REFUND",
}
export default DistributorRefundCandidateApprovalRejectionReason;
